import React from "react"
import {
    componentStyles,
    MultiMediaDisplay,
    MediaDisplayType,
    AspectMediaCore,
} from "@mallardbay/lib-react-components"

import { MediaType } from "~graphql/generated/graphql"
import type { ActivityFieldsFragment } from "~graphql/generated/graphql"
import Box from "~components/shared/todo-lib-react-components/box"

interface Props {
    readonly activity: ActivityFieldsFragment
    readonly shouldShowFullCard?: boolean
}

export default function ActivityCardMedia({
    activity,
    shouldShowFullCard,
}: Props) {
    const { images, video } = filterActivityMedia(activity)

    // for mobile view only show 1 image/video
    const mobileMedia = video ?? images[0]

    const hasMobileMedia = !!mobileMedia

    const styles = useStyles(hasMobileMedia)

    if (shouldShowFullCard) {
        return (
            <MultiMediaDisplay
                images={images}
                video={video}
                type={MediaDisplayType.GRID_COMPACT}
            />
        )
    }

    return (
        <Box style={styles.mediaBox}>
            <AspectMediaCore media={mobileMedia} aspectRatio={1} />
        </Box>
    )
}

function filterActivityMedia(activity: ActivityFieldsFragment) {
    const images = activity.attachments.filter(
        (attachment) => attachment.type === MediaType.Image
    )

    // at the moment we only support 1 video per activity
    const videos = activity.attachments.filter(
        (attachment) => attachment.type === MediaType.Video
    )

    const video = videos.length > 0 ? videos[0] : undefined

    return { images, video }
}

function useStyles(hasMobileMedia?: boolean) {
    return componentStyles({
        mediaBox: {
            display: hasMobileMedia ? "block" : "none",
            flexGrow: 3,
            flexBasis: 0,
            borderRadius: "xl",
            overflow: "hidden",
        },
    })
}
